<template lang="pug">
  div.bg-gray-100(class="lg:border-t.border-r")
    .h-full.overflow-scroll.max-w-xs.px-8.pt-2.pb-4(class="lg:max-w-xl lg:px-5 lg:pt-12 lg:pb-32 lg:fixed")
      ul
        collapse(v-for="(items, type) in links" :key="type")
          p.text-sm.text-blue-500.uppercase.text-gray-500(class="xl:text-xs") {{ formatText(type) }}
          template(slot="in-collapse")
            ul(class="xl:text-sm")
              li.pb-1.pl-3(v-for="item in items")
                router-link(class="hover:text-gray-900" :to="`/documentation/${type}/${item}`") {{ formatText(item) }}
</template>

<script>
  import collapse from './collapse';
  import path from 'path-browserify';

  export default {
    components: {
      collapse,
    },
    data () {
      return {
        links: {
          'getting-started': require.context('../documentation/getting-started/', true, /\.vue$/).keys().map(item => path.parse(item).name),
          'guidelines': require.context('../documentation/guidelines/', true, /\.vue$/).keys().map(item => path.parse(item).name),
          'tailwind-extensions': require.context('../documentation/tailwind-extensions/', true, /\.vue$/).keys().map(item => path.parse(item).name),
          'vue-generic-components': require.context('../documentation/vue-generic-components/', true, /\.vue$/).keys().map(item => path.parse(item).name),
          'vue-UI-elements': require.context('../documentation/vue-UI-elements/', true, /\.vue$/).keys().map(item => path.parse(item).name),
          'rails-helpers': require.context('../documentation/rails-helpers/', true, /\.vue$/).keys().map(item => path.parse(item).name),
        },
      };
    },
    computed: {
      start () {
        const items = require.context('../documentation/getting-started/', true, /\.vue$/);
        return items.keys().map(item => path.parse(item).name);
      },
      guidelines () {
        const items = require.context('../documentation/guidelines/', true, /\.vue$/);
        return items.keys().map(item => path.parse(item).name);
      },
      components ()  {
        const items = require.context('../documentation/vue-generic-components/', true, /\.vue$/);
        return items.keys().map(item => path.parse(item).name);
      },
    },
    methods: {
      formatText (string) {
        string = string.replace(/-/g, ' ');
        string = string.charAt(0).toUpperCase() + string.slice(1);
        return string;
      },
    },
  };
</script>
